<router-outlet></router-outlet>
<div *ngIf="isLoading| async" class="loader">
    <!-- Loading... -->
    <mat-progress-spinner color="primary" strokeWidth="5" mode="indeterminate">
    </mat-progress-spinner>
    <!-- <mat-spinner class="spinner"></mat-spinner> -->
</div>